import bonnet from "../../images/Products/bonnet.jpg";
import casquetteNike from "../../images/Products/casquetteNike.jpg";
import mens from "../../images/Products/mens.jpg";
import sweatermen from "../../images/Products/sweatermen.jpg";
import sweatpant from "../../images/Products/sweatpant.jpg";
import tshirt from "../../images/latestproducts/t-shirt.jpg";
import nikeshoes from "../../images/latestproducts/nikeshoes.jpg";
import hoodi from "../../images/latestproducts/hoodiesmen.jpg";

const MenProducts = [
  {
    image: bonnet,
    name: "cool style Bonnet",
    price: "$12.00 USD",
  },
  {
    image: casquetteNike,
    name: "Orange Nike Cap",
    price: "$14.00 USD",
  },
  {
    image: mens,
    name: "Cuff Shirt",
    price: "$19.99 USD",
  },
  {
    image: sweatermen,
    name: "Mens Sweater",
    price: "$52.90 USD",
  },
  {
    image: sweatpant,
    name: "Sweater dresses ",
    price: "$25.00 USD",
  },
  {
    image: hoodi,
    name: " men hoodi",
    price: "$19.99 USD",
  },
  {
    image: tshirt,
    name: "black men t-shirt",
    price: "$88.00 USD",
  },
  {
    image: nikeshoes,
    name: "new nike shoes",
    price: "$120.90 USD",
  },
];

export default MenProducts;
